import { render, staticRenderFns } from "./FormSubmit.vue?vue&type=template&id=2122c065&"
import script from "./FormSubmit.vue?vue&type=script&lang=js&"
export * from "./FormSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports